<template>
  <div
    class="candidate-placeholder relative"
    :class="{
      interactable: interactable,
      'candidate-placeholder-small': small
    }"
    draggable="false"
    @click="onClick"
  >
    <div
      class="icon"
      v-if="showIcon"
      :class="{
        'icon-small': small
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "CandidatePlaceholder",
  props: {
    /**
     * @var Whether to show the plus icon or empty circle
     */
    showIcon: {
      type: Boolean,
      default: true
    },
    /**
     * @var Whether this placeholder can be interacted with. If interactable, this placeholder shows a plus sign.
     * When interacted with, this placeholder emits a @click event.
     */
    interactable: {
      type: Boolean,
      default: false
    },
    /**
     * @var Change this placeholder to the smaller size
     */
    small: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onClick(event) {
      if (!this.interactable) {
        return;
      }
      this.$emit("click", event);
    }
  }
};
</script>

<style scoped>
.candidate-placeholder {
  border-radius: 1rem;
  width: 6rem;
  height: 8.6rem;
}
.candidate-placeholder-small {
  width: 4.2rem;
  height: 6.2rem;
}
.candidate-placeholder .icon {
  position: absolute;
  top: 1.5em;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  width: 4.125rem;
  height: 4.125rem;
}
.candidate-placeholder .icon-small {
  width: 2.6875rem;
  height: 2.6875rem;
}
.candidate-placeholder:not(.interactable) .icon {
  border: 1px solid var(--interaction-light);
}
#app.mouse .candidate-placeholder.interactable:hover {
  cursor: pointer;
}
.candidate-placeholder.interactable .icon {
  background-color: var(--interaction-light);
}
.candidate-placeholder.interactable .icon::after {
  content: "+";
  color: var(--interaction-dark);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
  font-size: 2.5rem;
  line-height: 1em;
  pointer-events: none;
  font-weight: normal;
}
#app.mouse .candidate-placeholder.interactable:hover .icon {
  opacity: 0.85;
}
.candidate-placeholder.interactable:active .icon {
  opacity: 0.7;
}
@media (min-width: 768px) {
  .candidate-placeholder {
    width: 7.05rem;
    height: 10.1rem;
  }
  .candidate-placeholder-small {
    width: 4.125rem;
    height: 6.3125rem;
  }
  .candidate-placeholder .icon {
    width: 4.90625rem;
    height: 4.90625rem;
  }
  .candidate-placeholder .icon-small {
    width: 3.03125rem;
    height: 3.03125rem;
  }
}
</style>
